import { blue, purple, teal } from "@mui/material/colors";
import { ResourceDetailsMetricKey, MetricPeriods } from "../types/metrics";
import { ResourceType } from "@/services/cloudchipr.api";

export const colorsByMetricKey: Record<ResourceDetailsMetricKey, string> = {
  cpu: blue["300"],
  database_connections: blue["300"],
  mem_available: purple["300"],
  mem_used: purple["300"],
  network_in: teal["300"],
  network_out: teal["300"],
  requests: blue["300"],

  provisioned_concurrency_usage_sum: blue["300"],
  total_compute_usage: blue["300"],
  amount_of_requests: blue["300"],
};

export const metricKeyLabels: Record<ResourceDetailsMetricKey, string> = {
  cpu: "CPU Utilization",
  database_connections: "DB Connections",
  mem_available: "Available Memory",
  mem_used: "Memory Utilization",
  network_in: "Network In",
  network_out: "Network Out",
  requests: "All Requests",
  provisioned_concurrency_usage_sum: "Provisioned Concurrency Usage",
  total_compute_usage: "Total Compute Usage",
  amount_of_requests: "Amount Of Requests",
};

export const metricsChartsPeriods: Record<
  MetricPeriods,
  { value: number; label: string; frequency: "hourly" | "daily" }
> = {
  "24h": { value: 24, label: "24 hours", frequency: "hourly" },
  "7d": { value: 7, label: "7 days", frequency: "daily" },
  "30d": { value: 30, label: "30 days", frequency: "daily" },
};

export const metricAvailableResourceTypes = new Set<ResourceType>([
  "ec2",
  "nat_gateway",
  "rds",
  "asg_ec2",
  "s3",
  "az_sql",
  "az_vm",
  "az_vmss_vm",
  "sql",
  "vm",
  "eks_ec2",
  "gke_vm",
  "az_aks_vm",
  "lambda",

  // k8s resources
  "kubernetes_node",
  "kubernetes_pod",
  "kubernetes_deployment",
  "kubernetes_daemon_set",
  "kubernetes_stateful_set",
]);
